// import { useHistory } from "react-router-dom";

// import { useState } from "react";
// import axios from "axios";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState(""); // State for error messages
//   const routerHistory = useHistory();

//   const handleLogin = async () => {
//     // Clear any previous error message
//     setErrorMessage("");

//     try {
//       // Access the backend URL from your environment variable
//       const backendUrl = process.env.REACT_APP_BACKEND_URL;

//       // Make sure the URL is available before making the request
//       if (!backendUrl) {
//         setErrorMessage("Backend URL is not configured. Please check your environment variables.");
//         return;
//       }

//       const response = await axios.post(
//         // Use the full URL by combining the backend URL and the API path
//         `${backendUrl}/api/auth`,
//         {
//           email,
//           password,
//         }
//       );
//       if (response.status === 200) {
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem("user", JSON.stringify(response.data.user));
//         routerHistory.push("/admin/tables");
//       }
//     } catch (error) {
//       // Use the errorMessage state to display the error on the page
//       setErrorMessage(error.response?.data?.msg || "Login failed");
//     }
//   };

//   return (
//     <>
//       <div className="container mx-auto px-4 h-full">
//         <div className="flex content-center items-center justify-center h-full">
//           <div className="w-full lg:w-4/12 px-4">
//             <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
//               <div className="rounded-t mb-0 px-6 py-6">
//                 {/* <div className="text-center mb-3">
//                   <h6 className="text-blueGray-500 text-sm font-bold">
//                     Sign in with
//                   </h6>
//                 </div>
//                 <div className="btn-wrapper text-center">
//                   <button
//                     className="bg-white active:bg-blueGray-50 text-blueGray-700 font-normal px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 uppercase shadow hover:shadow-md inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
//                     type="button"
//                   >
//                     <img
//                       alt="..."
//                       className="w-5 mr-1"
//                       src={require("assets/img/google.svg").default}
//                     />
//                     Google
//                   </button>
//                 </div> */}
//                 {/* <hr className="mt-6 border-b-1 border-blueGray-300" /> */}
//               </div>
//               <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
//                 <div className="text-blueGray-400 text-center mb-3 font-bold">
//                   <small>Sign in with credentials</small>
//                 </div>
//                 <form>
//                   {/* Display the error message if it exists */}
//                   {errorMessage && (
//                     <div className="text-red-500 text-center mb-4 text-sm font-semibold">
//                       {errorMessage}
//                     </div>
//                   )}

//                   <div className="relative w-full mb-3">
//                     <label
//                       className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
//                       htmlFor="grid-password"
//                     >
//                       Email
//                     </label>
//                     <input
//                       type="email"
//                       className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                       placeholder="Email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                   </div>

//                   <div className="relative w-full mb-3">
//                     <label
//                       className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
//                       htmlFor="grid-password"
//                     >
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                   </div>
//                   <div>
//                     <label className="inline-flex items-center cursor-pointer">
//                       <input
//                         id="customCheckLogin"
//                         type="checkbox"
//                         className="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
//                       />
//                       <span className="ml-2 text-sm font-semibold text-blueGray-600">
//                         Remember me
//                       </span>
//                     </label>
//                   </div>

//                   <div className="text-center mt-6">
//                     <button
//                       className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
//                       type="button"
//                       onClick={handleLogin}
//                     >
//                       Sign In
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//             {/* <div className="flex flex-wrap mt-6 relative">
//               <div className="w-1/2">
//                 <a
//                   href="#pablo"
//                   onClick={(e) => e.preventDefault()}
//                   className="text-blueGray-200"
//                 >
//                   <small>Forgot password?</small>
//                 </a>
//               </div>
//               <div className="w-1/2 text-right">
//                 <Link to="/auth/register" className="text-blueGray-200">
//                   <small>Create new account</small>
//                 </Link>
//               </div>
//             </div> */}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
import { useHistory } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // New state for loading
  const routerHistory = useHistory();

  const handleLogin = async () => {
    setErrorMessage("");
    setLoading(true); // Set loading to true when the request starts

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;

      if (!backendUrl) {
        setErrorMessage(
          "Backend URL is not configured. Please check your environment variables."
        );
        setLoading(false); // Set loading to false on error
        return;
      }

      const response = await axios.post(`${backendUrl}/api/auth`, {
        email,
        password,
      });

      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        routerHistory.push("/admin/tables");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.msg || "Login failed");
    } finally {
      setLoading(false); // Set loading to false when the request is complete
    }
  };

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <hr className="mt-6 border-b-1 border-blueGray-300" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <div className="text-blueGray-400 text-center mb-3 font-bold">
                  <small>Sign in with credentials</small>
                </div>
                <form>
                  {errorMessage && (
                    <div className="text-red-500 text-center mb-4 text-sm font-semibold">
                      {errorMessage}
                    </div>
                  )}

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                      />
                      <span className="ml-2 text-sm font-semibold text-blueGray-600">
                        Remember me
                      </span>
                    </label>
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleLogin}
                      disabled={loading} // Disable the button while loading
                    >
                      {loading ? (
                        <>
                          <i className="fas fa-circle-notch fa-spin"></i>
                          <span className="ml-2">Signing In...</span>
                        </>
                      ) : (
                        "Sign In"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* <div className="flex flex-wrap mt-6 relative">...</div> */}
          </div>
        </div>
      </div>
    </>
  );
}